import { slide } from './lib/_slideshow.js';
import { kvSlide } from './lib/_kv_vol1.js';
import { common } from './_common.js';


export class Framework {
	constructor(){
		//this.pageinfo = loc.all();
		this.checkURL();
		//console.log(this.pageinfo);
	}
	
	checkURL(){
		this.afterChangePage();
	}
	
	
	afterChangePage(){
		common.init();
		slide.init();
		kvSlide.init();
		common.resize();
		common.nav();
		setTimeout(function(){
			document.querySelector("#wrapper").classList.remove("disable");
			setTimeout(function(){
				document.querySelector("#kv").classList.add("active");
			}, 400);
		}, 100);
		
	}
}